// Print Notes provider filter keyed by provider ID (owner 2026-10-08, item 8:
// "Yes pls switch those as well"). Same model as the dashboard
// (utils/providerDirectory.providerFilterModel).
//
// v2 POST /scheduler/schedule_list rows carry `providerid` (the BOOKED
// provider) and `providername`, which is appointment_master.linked_provider
// relabelled - the provider the visit is shown under (a Select Provider
// reassignment, or the booked provider's own name in one of its spellings).
// So each row is read as { providerid, linked_provider: providername }; it is
// never treated as the booked provider's Athena name (that would teach the
// model a reassigned provider's name under the booked id).
// Display only: nothing is written back.
import { EMPTY_PROVIDER_DIRECTORY, providerFilterModel } from "../utils/providerDirectory";

const asModelRow = (a) => ({
  providerid: a?.providerid,
  linked_provider: typeof a?.providername === "string" ? a.providername : "",
});

// { keyOf(row) -> "id:<id>" | "name:<name>" | "", options: [{ value, label, name, names }] }
export function printProviderModel(
  appointments,
  directory = EMPTY_PROVIDER_DIRECTORY,
  { doctorLabels = true, aliases = null } = {},
) {
  const list = Array.isArray(appointments) ? appointments.filter(Boolean) : [];
  const rows = list.map(asModelRow);
  const byRow = new Map(list.map((a, i) => [a, rows[i]]));
  const model = providerFilterModel(rows, directory, { doctorLabels, aliases });
  const keyOf = (a) => model.keyOf(byRow.get(a) || asModelRow(a));
  return { keyOf, options: model.options };
}
